// react
import React from 'react'
// antd-pro
import {ProFormSelect, ProFormText} from '@ant-design/pro-components'
import Api from '@/api'
import {AppType} from '@/enum'

/**
 * 滴滴配置表单项
 * @constructor
 */
const DidiFormItems = () => {
  return (
    <>
      <ProFormText
        name={["config", "clientId"]}
        label={"ClientId"}
        placeholder={"请输入clientId"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入clientId"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "clientSecret"]}
        label={"ClientSecret"}
        placeholder={"请输入ClientSecret"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入ClientSecret"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "grantType"]}
        label={"GrantType"}
        placeholder={"请输入GrantType"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入GrantType"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "signKey"]}
        label={"SignKey"}
        placeholder={"请输入SignKey"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入SignKey"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "companyId"]}
        label={"CompanyId"}
        placeholder={"请输入CompanyId"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入CompanyId"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "phone"]}
        label={"Phone"}
        placeholder={"请输入Phone"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入Phone"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormSelect
        name={["config", "envId"]}
        label={"环境地址"}
        placeholder={"请选择所属环境地址"}
        required
        width={"lg"}
        rules={[{
          required: true,
          message: "请选择所属环境地址"
        }]}
        fieldProps={{
          fieldNames: {
            label: "envName",
            value: "id"
          }
        }}
        request={async () => {
          const _data: any = await Api.Common.EnvList({appType: AppType.DIDI})
          return _data
        }}
      />
      <ProFormText
        name={["config", "remark"]}
        label={"remark"}
        placeholder={"请输入remark"}
        width={"lg"}
        rules={[
          {
            message: "请输入remark"
          }
      ]}
      />
    </>
  )
}

export default DidiFormItems
